__turbopack_context__.v({
  "gdprCompliantHeader": "policies-module-scss-module__WtpEiG__gdprCompliantHeader",
  "hipaaCertificate": "policies-module-scss-module__WtpEiG__hipaaCertificate",
  "pageContainer": "policies-module-scss-module__WtpEiG__pageContainer",
  "privacyShieldCertificate": "policies-module-scss-module__WtpEiG__privacyShieldCertificate",
  "soc2Certificate": "policies-module-scss-module__WtpEiG__soc2Certificate",
});
